import React from 'react';
import Table from 'src/ui/library/Table';
//import TextInput from 'src/ui/library/TextInput';

class Home extends React.Component {
  constructor(props) {
    super(props);

    const rows = [
      ['gregory nowakowski', 'charlotte', 'awofk awokf aowk', 'awfkawofko'],
      ['joe thomas', 'new york city', 'awf awf awf ', 'awf awfaijwfaijfwi jawf'],
      ['rob hall', 'dallas', 'kawifaiwfjiwaf awifj', 'iwafj awifj aiwjf ijawfi jawifj'],
    ];

    this.state = {
      readOnly: true,
      rows,
    };
  }

  toggleReadOnly = () => {
    this.setState(prevState => ({ readOnly: !prevState.readOnly }));
  };

  render() {
    const columns = [
      {
        id: 'name',
        displayText: 'Member name',
        // renderComponent: (value, tableMeta, updateValueFn) => {
        //   return <TextInput value={value} onChange={event => updateValueFn(event.target.value)} />;
        // },
        sortable: false,
      },
      {
        id: 'location',
        displayText: 'Location',
        sortable: false,
      },
      {
        id: 'voco location',
        displayText: 'Voco Location',
        sortable: false,
      },
      {
        id: 'awfawf location',
        displayText: 'Todo Location',
        sortable: false,
      },
    ];

    const onTableChange = (actionType, data) => {
      switch (actionType) {
        case 'cellValueUpdate':
          const {
            model: { rows },
          } = data;

          this.setState({ rows: rows.map(row => row.map(col => col.value)) });
          break;
        case 'rowsDeleted': {
          const { newRows } = data;
          this.setState({ rows: newRows });
          break;
        }
        case 'rowAdded': {
          const { newRows } = data;
          this.setState({ rows: newRows });
          break;
        }
        default:
          break;
      }
    };

    return (
      <div className="margin-content">
        <button onClick={this.toggleReadOnly}>Button to simulate going between read only & edit mode</button>
        <br />
        <br />
        <Table pagination={true} rows={this.state.rows} columns={columns} selectableRows={true} onTableChange={onTableChange} />
      </div>
    );
  }
}

export default Home;
